import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const CreacionEVSApi = () => {
    const [cargando, setCargando] = useState(false);

    const getClientes = async (params) => {
        return api
            .get("cliente", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getProductosAProducir = async (params) => {
        return api
            .get("materia_prima/productos_produccion", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getConsumidoresFinales = async (params) => {
        return api
            .get("consumidores_finales", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const crearRegistroEVS = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("evs", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarRegistroEVS = async (id, data) => {
        try {
            setCargando(true);
            const response = await api.put(`evs/${id}`, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getDetalleRegistroEVS = async (id) => {
        try {
            setCargando(true);

            const response = await api.get(`evs/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getClientes,
        getProductosAProducir,
        getConsumidoresFinales,
        crearRegistroEVS,
        actualizarRegistroEVS,
        getDetalleRegistroEVS,


        cargando,
    };
};
